'use strict';
import { environment } from '@environments/environment';
angular.module('schoolLinqApp').factory('purchaseAddEditHelper', [
	'$uibModal',
	function ($uibModal) {
		function openAddEditDialog(moduleName, selectedId, purchasingType, closeActionCallBack) {
			const addEditDialogController = [
				'$scope',
				'$q',
				'$uibModalInstance',
				'siteService',
				'vendorService',
				'accountService',
				'purchaseOrderSetupService',
				'BUSY_MESSAGE',
				'ACCOUNT_TYPES',
				'PURCHASING_TYPES',
				'PO_STATUS',
				'USER_CLAIMS',
				'TAX_RATE_TYPES',
				'purchaseOrderService',
				'accountStructureService',
				'authInterceptorService',
				'utilsService',
				'authService',
				'dialogHelper',
				'dialogSearchHelper',
				'unitService',
				function (
					$scope,
					$q,
					modalInstance,
					siteService,
					vendorService,
					accountService,
					purchaseOrderSetupService,
					BUSY_MESSAGE,
					ACCOUNT_TYPES,
					PURCHASING_TYPES,
					PO_STATUS,
					USER_CLAIMS,
					TAX_RATE_TYPES,
					purchaseOrderService,
					accountStructureService,
					authInterceptorService,
					utilsService,
					authService,
					dialogHelper,
					dialogSearchHelper,
					unitService
				) {
					// this will listen for route changes (like the user clicking the browsers Back button)
					// and ignore them so they will stay on the modal.
					$scope.$on('$locationChangeStart', function (event) {
						event.preventDefault();
					});

					angular.extend($scope, {
						getViewModel: function () {
							const model = {
								module: moduleName,
								purchasingType: purchasingType, //Requisition = 1, PurchaseOrder = 2
								states: [],
								sites: [],
								sitePOSetup: null,
								postalCodeMinLength: '0',
								typeaheadLimit: 10,
								errors: null,
								validationErrors: [],
								busyMessage: BUSY_MESSAGE.Loading,
								siteAccounting: authService.authentication.siteAccounting,
								selectedId: selectedId,
								addAnother: false,
								approvalUsers: [],
								filteredApprovalUsers: [],
								currentUser: null,
								canPrintPOs: authService.isAccessible(USER_CLAIMS.lsb, 'purchasing', 'PrintSendPOs'),
								isReadOnly:
									purchasingType === PURCHASING_TYPES.Requisition
										? authService.isReadOnly(USER_CLAIMS.lsb, 'ManageRequisitions', 'purchasing')
										: authService.isReadOnly(USER_CLAIMS.lsb, 'ManagePOs', 'purchasing'),
								nextVendorCode: null,
							};
							model.purchasingTypeDesc = purchasingType === PURCHASING_TYPES.Requisition ? 'Requisition' : 'Purchase Order';

							if (purchasingType === PURCHASING_TYPES.PurchaseOrder) {
								model.viewPurchaseOrder = {
									selectedCopyNumber: 1,
									images: [],
									activeImage: 0,
									printVendorCopy: false,
									printCopyTwo: false,
									printCopyThree: false,
									confirmText: '',
									success: false,
								};
							}

							return model;
						},

						initialize: function (addAnother) {
							$scope.vm = $scope.getViewModel();

							if (addAnother) {
								$scope.vm.selectedId = null;
							}

							var promises = [
								$scope.getSitePOSetup(),
								$scope.getStates(),
								$scope.getPurchaseOrderStatus(),
								$scope.getAccountStructures(),
								$scope.getSites(),
								$scope.getVendors(),
								$scope.getTaxRateTypes(),
								$scope.loadTINTypes(),
								$scope.loadVendor1099Boxes(),
								$scope.loadNextVendorCode(),
							];

							if (purchasingType === PURCHASING_TYPES.Requisition) {
								promises.push($scope.getApprovalUsers());
							}

							$scope.busyPromise = $q.all(promises).then(function () {
								$scope.resetNewPO();
							});
						},

						addPOReqGrandTotalWatch() {
							$scope.poReqGrandTotal = 0;
							if (!$scope.newPO.isClosed && !$scope.vm.isReadOnly) {
								$scope.$watch('poReqGrandTotal', function (newValue, oldValue) {
									if (oldValue !== newValue) {
										$scope.syncShippingCost();
									}
								});
							}
						},

						resetNewPO: function () {
							$scope.newPO = {
								Id: 0,
								StatusId: PO_STATUS.Open,
								PurchasingTypeId: purchasingType,
								PurchaseOrderAccounts: [],
								EffectiveDT: new Date(new Date().setHours(0, 0, 0, 0)),
								DeliverDT: new Date(new Date().setHours(0, 0, 0, 0)),
								OrderCountry: 'US',
								isClosed: false,
								ShippingCost: 0,
								ShowOverBudgetWarnings: $scope.vm.sitePOSetup !== null ? $scope.vm.sitePOSetup.ShowOverBudgetWarnings : false,
								NextApprover: null,
								maxAmountExceeded: false,
							};

							if ($scope.vm.selectedId) {
								$scope.vm.busyMessage = BUSY_MESSAGE.Loading;
								$scope.busyPromise = $q.all([$scope.getPOReq($scope.vm.selectedId)]);
							} else {
								if ($scope.vm.sites.length === 1) {
									// select the site for the user.
									$scope.vm.busyMessage = BUSY_MESSAGE.Loading;
									$scope.busyPromise = $q.all([$scope.getDefaultSite($scope.vm.sites[0].Id)]);
								}
								$scope.addPOReqGrandTotalWatch();
							}
						},

						getPOReq: function (id) {
							return purchaseOrderService.getPurchaseOrder(id).then(finishGettingPurchaseOrder);

							function finishGettingPurchaseOrder(response) {
								$scope.newPO = response.data.purchaseOrder;
								if ($scope.newPO !== undefined) {
									$scope.newPO.selectedVendor = $scope.newPO.Vendor;
									$scope.newPO.EffectiveDT = moment($scope.newPO.EffectiveDT).toDate();
									$scope.newPO.DeliverDT = moment($scope.newPO.DeliverDT).toDate();
									$scope.newPO.isClosed = $scope.newPO.StatusId === PO_STATUS.Closed;

									// If S&H was handled the old way we need to set S&H total
									if (!$scope.newPO.ShippingCost) {
										if (!$scope.newPO.PurchaseOrderAccounts) {
											$scope.newPO.ShippingCost = 0;
										} else {
											$scope.newPO.ShippingCost = _.reduce(
												$scope.newPO.PurchaseOrderAccounts,
												function (num, account) {
													return (
														num +
														_.reduce(
															account.PurchaseOrderLines,
															function (num, line) {
																return num + (line.IsShipping ? parseFloat(line.Amount) : 0);
															},
															0
														)
													);
												},
												0
											);

											// if unpaid remove the line items for them
											if ($scope.newPO.StatusId === PO_STATUS.Open) {
												angular.forEach($scope.newPO.PurchaseOrderAccounts, function (account) {
													$scope.filterOutShippingAndHandling(account);
												});
											}
										}
									}

									if ($scope.newPO.ShippingCost > 0 && !($scope.newPO.isClosed || $scope.vm.isReadOnly)) {
										// Need to ensure the sum of line shippingCosts equals entered shipping cost.
										if ($scope.totalCalculatedSH() !== Number($scope.newPO.ShippingCost)) {
											$scope.syncShippingCost(true);
										}
									}

									$scope.addPOReqGrandTotalWatch();
								}
								$scope.newPO.NextApprover = null;

								return angular.noop;
							}
						},

						filterOutShippingAndHandling: function (account) {
							if (account.PurchaseOrderLines) {
								account.PurchaseOrderLines = account.PurchaseOrderLines.filter(function (x) {
									return !x.IsShipping;
								});
							}
						},

						getDefaultSite: function (siteId) {
							return siteService.getSite(siteId).then(finishGettingSite);

							function finishGettingSite(response) {
								$scope.newPO.SiteId = response.data.site.Id;
								$scope.newPO.ShipTo = response.data.site.SiteCode + ' : ' + response.data.site.SiteName;
								$scope.newPO.ShipToName = response.data.site.ShipToName;
								$scope.newPO.ShipAttn = response.data.site.ShipToAttn;
								$scope.newPO.ShipAddress1 = response.data.site.ShipToAddress1;
								$scope.newPO.ShipAddress2 = response.data.site.ShipToAddress2;
								$scope.newPO.ShipCity = response.data.site.ShipToCity;
								$scope.newPO.ShipState = response.data.site.ShipToState;
								$scope.newPO.ShipZip = response.data.site.ShipToZip;
								$scope.newPO.Site = response.data.site;

								if ($scope.vm.siteAccounting === true) {
									// load the sitePOSetup
									return purchaseOrderSetupService.getBySiteId(siteId).toPromise().then(finishGetSitePOSetup);
								}
								return angular.noop;
							}

							function finishGetSitePOSetup(response) {
								$scope.vm.sitePOSetup = response;

								if (!$scope.vm.sitePOSetup || $scope.vm.sitePOSetup.Id === 0) {
									$scope.newPO.SiteId = null;
									$scope.newPO.ShipTo = null;
									$scope.newPO.ShipToName = null;
									$scope.newPO.ShipAttn = null;
									$scope.newPO.ShipAddress1 = null;
									$scope.newPO.ShipAddress2 = null;
									$scope.newPO.ShipCity = null;
									$scope.newPO.ShipState = null;
									$scope.newPO.ShipZip = null;
									$scope.newPO.Site = null;
									$scope.newPO.ShowOverBudgetWarnings = true;
								}
								return angular.noop;
							}
						},

						getSites: function () {
							return siteService.getSites().then(finishLoadingSites);

							function finishLoadingSites(response) {
								$scope.vm.sites = response.data.sites;
								return angular.noop;
							}
						},

						loadTINTypes: function () {
							return utilsService.getTINTypes().then(finishLoadingTINTypes);

							function finishLoadingTINTypes(response) {
								$scope.vm.tinTypes = response.data;
							}
						},

						loadVendor1099Boxes: function () {
							return utilsService.getVendor1099Boxes().then(finishLoadingVendor1099Boxes);

							function finishLoadingVendor1099Boxes(response) {
								$scope.vm.vendor1099Boxes = response.data;
							}
						},

						loadNextVendorCode: function () {
							return unitService.getNextVendorCode().then(_.partial(finishLoadingNextVendorCode));

							function finishLoadingNextVendorCode(response) {
								$scope.vm.nextVendorCode = response.data.data;
							}
						},

						getSite: function (siteId) {
							return siteService.getSite(siteId).then(finishLoadingSite);

							function finishLoadingSite(response) {
								$scope.newPO.SiteId = response.data.site.Id;
								$scope.newPO.ShipTo = response.data.site.SiteCode + ' : ' + response.data.site.SiteName;
								$scope.newPO.ShipToName = response.data.site.ShipToName;
								$scope.newPO.ShipAttn = response.data.site.ShipToAttn;
								$scope.newPO.ShipAddress1 = response.data.site.ShipToAddress1;
								$scope.newPO.ShipAddress2 = response.data.site.ShipToAddress2;
								$scope.newPO.ShipCity = response.data.site.ShipToCity;
								$scope.newPO.ShipState = response.data.site.ShipToState;
								$scope.newPO.ShipZip = response.data.site.ShipToZip;
								$scope.newPO.Site = response.data.site;

								if ($scope.vm.siteAccounting === true) {
									// load the sitePOSetup
									return purchaseOrderSetupService.getBySiteId(siteId).toPromise().then(finishGetSitePOSetup);
								}

								return angular.noop;
							}

							function finishGetSitePOSetup(response) {
								$scope.vm.sitePOSetup = response;

								if ($scope.vm.siteAccounting === true && parseInt($scope.vm.sitePOSetup.Id) === 0) {
									$scope.message = 'Purchase Order Setup for Site:"' + $scope.newPO.ShipTo + '" is missing!';
									$scope.messageDetail =
										'Purchase Order Setup can be added by going to "SYSTEM SETTINGS >> SYSTEM SETUP >> Purchase Order Setup".';

									$uibModal.open({
										template: require('@ajs/templates/warning-message-dialog.html'),
										backdrop: 'static',
										keyboard: false,
										scope: $scope,
										controller: [
											'$scope',
											'$uibModalInstance',
											function ($scope, modalPOSetupInstance) {
												angular.extend($scope, {
													cancel: function () {
														$scope.newPO.SiteId = null;
														$scope.newPO.ShipTo = null;
														$scope.newPO.ShipToName = null;
														$scope.newPO.ShipAttn = null;
														$scope.newPO.ShipAddress1 = null;
														$scope.newPO.ShipAddress2 = null;
														$scope.newPO.ShipCity = null;
														$scope.newPO.ShipState = null;
														$scope.newPO.ShipZip = null;
														$scope.newPO.Site = null;

														modalPOSetupInstance.close();
													},
												});
											},
										],
									});
									return angular.noop;
								}
								return angular.noop;
							}
						},

						getVendors: function () {
							return vendorService.searchVendor(null, 1).then(finishLoadingSites);

							function finishLoadingSites(response) {
								$scope.vm.vendors = response.data;
								return angular.noop;
							}
						},

						getVendor: function (vendorId) {
							return vendorService.getVendor(vendorId).then(finishLoadingVendor);

							function finishLoadingVendor(response) {
								if (!_.findWhere($scope.vm.vendors, { Id: vendorId })) {
									$scope.vm.vendors.push(response.data.vendor);
								}
								$scope.newPO.selectedVendor = response.data.vendor;
								$scope.newPO.VendorId = response.data.vendor.Id;
								$scope.newPO.OrderTo = response.data.vendor.ShortName + ' - ' + response.data.vendor.VendorName;
								$scope.newPO.OrderAttn = response.data.vendor.OrderAttn;
								$scope.newPO.OrderCountry = response.data.vendor.OrderCountry;
								if (!$scope.newPO.OrderCountry) {
									// if there is no Country then select 'US' as the Country
									$scope.newPO.OrderCountry = 'US';
								}
								$scope.newPO.OrderAddress1 = response.data.vendor.OrderAddress1;
								$scope.newPO.OrderAddress2 = response.data.vendor.OrderAddress2;
								$scope.newPO.OrderCity = response.data.vendor.OrderCity;
								$scope.newPO.OrderState = response.data.vendor.OrderState;
								$scope.newPO.OrderZip = response.data.vendor.OrderZip;
								$scope.newPO.OrderPhone = response.data.vendor.OrderPhone;
								$scope.newPO.OrderFax = response.data.vendor.OrderFax;
								$scope.newPO.Vendor = response.data.vendor;

								// After selecting a vender we need to loop over the Items in the PO to fix the Taxes
								angular.forEach($scope.newPO.PurchaseOrderAccounts, function (account) {
									angular.forEach(account.PurchaseOrderLines, function (line) {
										$scope.changeTaxType(line);
									});
								});

								return angular.noop;
							}
						},

						searchVendorbyName: function (value) {
							return vendorService.searchVendor(value, 1, $scope.vm.typeaheadLimit).then(finishSearchVendors);

							function finishSearchVendors(response) {
								return response.data;
							}
						},

						showDialogSearchHelperVendors: function () {
							let modalConfig = null;
							let selectFunction = function (vendor) {
								$scope.vm.busyMessage = BUSY_MESSAGE.Loading;
								$scope.busyPromise = $scope.getVendor(vendor.Id);
								$scope.purchaseOrderForm.$setDirty();
							};

							dialogSearchHelper.searchVendors(modalConfig, selectFunction);
						},

						getPurchaseOrderStatus: function () {
							return utilsService.getPurchaseOrderStatuses().then(finishLoadingPurchaseOrderStatuses);

							function finishLoadingPurchaseOrderStatuses(response) {
								$scope.vm.purchaseOrderStatus = _.filter(response.data.purchaseOrderStatus, function (status) {
									return status.Id !== 3;
								});
								$scope.vm.purchaseOrderStatus.unshift({ Id: [1, 2], Description: 'All' });
								return angular.noop;
							}
						},

						getAccountStructures: function () {
							return accountStructureService.getStructure().then(finishLoadingAccountStructures);

							function finishLoadingAccountStructures(response) {
								const accountStructures = response.data.accountStructure;
								$scope.vm.unifiedAccountMask = accountStructures.UnifiedAccountMask;
								// we will only show the mask if there is a unified mask
								$scope.vm.expenseAccountMask = $scope.vm.unifiedAccountMask;
								return angular.noop;
							}
						},

						getSitePOSetup: function () {
							if ($scope.vm.siteAccounting !== true) {
								return purchaseOrderSetupService.getBySiteId(null).toPromise().then(finishGetPOSetup);
							}

							function finishGetPOSetup(response) {
								$scope.vm.sitePOSetup = response;
								return angular.noop;
							}
						},

						getStates: function () {
							return utilsService.getStates().then(finishLoadingStates);

							function finishLoadingStates(response) {
								$scope.vm.states = response.data.states;

								return angular.noop;
							}
						},

						getTaxRateTypes: function () {
							return utilsService.getTaxRateTypes().then(finishLoadingTaxRateTypes);

							function finishLoadingTaxRateTypes(response) {
								$scope.vm.taxRateTypes = response.data;
							}
						},

						getApprovalUsers: function () {
							return purchaseOrderService.getApprovalUsers().then(finishApprovalUsers);

							function finishApprovalUsers(response) {
								var approvalUsers = response.data.map(function (item) {
									return {
										userName: item.UserName.toUpperCase(),
										display: item.UserName.toUpperCase(),
										ordinal: item.Ordinal,
									};
								});

								approvalUsers.unshift({ userName: null, display: 'Next Approver', ordinal: 0 });
								$scope.approvalUsers = approvalUsers;
							}
						},

						canApprove: function () {
							if (
								!$scope.approvalUsers ||
								$scope.approvalUsers.length === 0 ||
								$scope.purchaseOrderForm.$dirty === true ||
								!$scope.vm.selectedId > 0
							) {
								return false;
							}

							const curUserName = authService.authentication.userName.toUpperCase();
							const found = $scope.approvalUsers.find((user) => user.userName === curUserName);
							$scope.currentUser = found;

							if (found) {
								$scope.filteredApprovalUsers = _.filter($scope.approvalUsers, function (user) {
									return user.ordinal < found.ordinal;
								});
								return true;
							}

							return false;
						},

						nextApproverResetDirty: function () {
							$scope.purchaseOrderForm.$setPristine();
						},

						stateHelper: {
							getStateLabel: function (countryCode) {
								if (!countryCode || $scope.vm.states.length === 0) return 'State';

								var country = _.find($scope.vm.states, function (c) {
									return c.CountryCode === countryCode;
								});
								return country.LabelName;
							},
							filterStates: function (countryCode) {
								if (!countryCode || $scope.vm.states.length === 0) return;

								var country = _.find($scope.vm.states, function (c) {
									return c.CountryCode === countryCode;
								});
								return country.StateCodes;
							},
						},

						selectInvoiceFromList: function (item) {
							$uibModal.open({
								template: require('@ajs/templates/fund/purchasing/purchaseOrder-select-invoice-modal.html'),
								backdrop: 'static',
								keyboard: false,
								scope: $scope,
								size: 'topMoveUp',
								controller: [
									'$scope',
									'$uibModalInstance',
									function ($scope, modalInvoiceFromList) {
										$scope.vm.selectInvoiceStartIndex = 0;
										$scope.vm.selectInvoiceBarLimit = 10;

										$scope.AllInvoices = item.PurchaseOrderInvoices;
										$scope.filteredInvoiceList = [];

										angular.extend($scope, {
											cancel: function () {
												modalInvoiceFromList.close();
											},
											selectInvoice: function (invoiceId) {
												var payableInvoiceScope = $scope.$new();
												$controller('payableInvoicesController', {
													$scope: payableInvoiceScope,
												});

												payableInvoiceScope.vm.newEditInvoice(invoiceId, false, true);
											},
										});
									},
								],
							});
						},

						addVendor: function () {
							$uibModal
								.open({
									template: require('@ajs/templates/fund/payable/vendor-add-modal.html'),
									backdrop: 'static',
									keyboard: false,
									scope: $scope,
									controller: [
										'$scope',
										'$uibModalInstance',
										'vendorService',
										function ($scope, addVendorInstance, vendorService) {
											$scope.newVendor = {
												ShortName: $scope.vm.nextVendorCode,
												VendorName: null,
												FederalTaxID: null,
												RemitAttn: null,
												RemitCountry: 'US',
												RemitAddress1: null,
												RemitAddress2: null,
												RemitCity: null,
												RemitState: null,
												RemitZip: null,
											};
											angular.extend($scope, {
												cancel: function () {
													$scope.vm.errors = null;
													addVendorInstance.close();
												},
												save: function () {
													var isValid;
													// validate Zip
													$scope.vendorForm.remitZip.$setValidity('validZip', true);
													$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', true);
													$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', true);
													if (
														$scope.newVendor.RemitCountry &&
														$scope.newVendor.RemitCountry.length > 0 &&
														$scope.newVendor.RemitZip &&
														$scope.newVendor.RemitZip.length > 0
													) {
														isValid = isPostalCodeValid($scope.newVendor.RemitCountry, $scope.newVendor.RemitZip);
														switch ($scope.newVendor.RemitCountry) {
															case 'US':
																$scope.vendorForm.remitZip.$setValidity('validZip', isValid);
																break;
															case 'CA':
																$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', isValid);
																break;
															default:
																$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', isValid);
																break;
														}
													}
													if (!$scope.vendorForm.$valid) return false;

													$scope.busyPromise = vendorService.addVendor($scope.newVendor).then(function (response) {
														if (response.data.isValid) {
															addVendorInstance.close(response.data.vendorId);
															$scope.loadNextVendorCode();
														} else {
															$scope.vm.errors = response.data.errors;
														}
													});
												},
											});
										},
									],
								})
								.result.then(function (vendorId) {
									if (vendorId) {
										$scope.getVendor(vendorId);
										$scope.purchaseOrderForm.$setDirty();
										return;
									}
								});
						},

						addAccount: function () {
							$scope.newPO.PurchaseOrderAccounts.push({
								Id: 0,
								PurchaseOrderLines: [
									{
										Id: 0,
										TaxRateTypeId: parseInt(TAX_RATE_TYPES.Goods),
										UnitCost: 0,
										StateTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateGoods : 0,
										CountyTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateGoods : 0,
										LocalTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateGoods : 0,
										IsShipping: false,
										IsDiscount: false,
										budgetExceeded: false,
									},
								],
							});

							$scope.setElementFocus(`account${$scope.newPO.PurchaseOrderAccounts.length - 1}`, false, true);
							$scope.purchaseOrderForm.$setDirty();
						},

						removeAccount: function (index) {
							$scope.newPO.PurchaseOrderAccounts.splice(index, 1);
							$scope.purchaseOrderForm.$setDirty();
						},

						addLine: function (account) {
							account.PurchaseOrderLines.push({
								Id: 0,
								TaxRateTypeId: parseInt(TAX_RATE_TYPES.Goods),
								UnitCost: 0,
								StateTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateGoods : 0,
								CountyTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateGoods : 0,
								LocalTaxRate: $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateGoods : 0,
								IsShipping: false,
								IsDiscount: false,
							});

							// Set focus to qty input
							const parentIndex = $scope.getAccountParentIndex(account);
							const index =
								_.filter(account.PurchaseOrderLines, function (e) {
									return e.IsShipping != true && e.IsDiscount != true;
								}).length - 1;

							$scope.setElementFocus(`qty${index}_${parentIndex}`, true);
							$scope.purchaseOrderForm.$setDirty();
						},

						removeLine: function (account, line) {
							let index = _.findIndex(account.PurchaseOrderLines, {
								$$hashKey: line.$$hashKey,
							});
							account.PurchaseOrderLines.splice(index, 1);
							$scope.purchaseOrderForm.$setDirty();
						},

						hasShipping: function (account) {
							var hasShipping = _.findWhere(account.PurchaseOrderLines, {
								IsShipping: true,
							});
							return hasShipping ? true : false;
						},

						addDiscount: function (account) {
							const discountType = this.getDiscountType(account);
							const isGoods = discountType === parseInt(TAX_RATE_TYPES.Goods);
							account.PurchaseOrderLines.push({
								Id: 0,
								Quantity: 1,
								Unit: 'DC',
								Description: 'Discount',
								TaxRateTypeId: discountType,
								UnitCost: 0,
								StateTaxRate: $scope.newPO.selectedVendor && isGoods ? $scope.newPO.selectedVendor.StateTaxRateGoods : 0,
								CountyTaxRate: $scope.newPO.selectedVendor && isGoods ? $scope.newPO.selectedVendor.CountyTaxRateGoods : 0,
								LocalTaxRate: $scope.newPO.selectedVendor && isGoods ? $scope.newPO.selectedVendor.LocalTaxRateGoods : 0,
								IsDiscount: true,
								IsPercent: false,
								AmountPercent: 0,
								TotalTax: 0,
							});

							const parentIndex = $scope.getAccountParentIndex(account);
							$scope.setElementFocus(`ucAmount${0}_${parentIndex}`, true);
							$scope.purchaseOrderForm.$setDirty();
						},

						getDiscountType: function (account) {
							var discount = _.where(account.PurchaseOrderLines, {
								IsDiscount: true,
							})[0];
							return discount && parseInt(discount.TaxRateTypeId) === parseInt(TAX_RATE_TYPES.Goods)
								? parseInt(TAX_RATE_TYPES.Service)
								: parseInt(TAX_RATE_TYPES.Goods);
						},

						hasDiscounts: function (account) {
							var discounts = _.where(account.PurchaseOrderLines, {
								IsDiscount: true,
							});
							return discounts && discounts.length > 1 ? true : false;
						},

						taxRateTypesDisabled: function (account) {
							return this.hasDiscounts(account);
						},

						onAmountPercentTypeChange: function (parentIndex, line) {
							line.UnitCost = 0;
							line.AmountPercent = 0;
							const name = line.IsPercent === true ? `ucPercent0_${parentIndex}` : `ucAmount0_${parentIndex}`;
							$scope.setElementFocus(name, true);
						},

						onAmountPercentKeyDown: function (event, parentIndex, line) {
							const keyCode = event.keyCode;
							// 32 = space, 13 = enter

							if (keyCode == 13) {
								line.IsPercent = !line.IsPercent;
								$scope.onAmountPercentTypeChange(parentIndex, line);
								event.preventDefault();
							}
						},

						applyDiscountAmtPctChange: function (account, discount) {
							switch (discount.IsPercent) {
								case true:
									const lines = account.PurchaseOrderLines.filter(
										(i) => !i.IsDiscount && !i.IsShipping && parseInt(i.TaxRateTypeId) === parseInt(discount.TaxRateTypeId)
									);
									const merchTotal = _.reduce(
										lines,
										function (total, line) {
											return parseFloat(total + line.Amount);
										},
										0
									);

									discount.UnitCost = emsRound(emsRound(Math.abs(discount.AmountPercent) / 100) * merchTotal, 4) * -1;

									break;
								default:
									discount.UnitCost = Math.abs(discount.AmountPercent) * -1;
									break;
							}
						},

						changeTaxType: function (line) {
							switch (parseInt(line.TaxRateTypeId) || 1) {
								case parseInt(TAX_RATE_TYPES.Service):
									// Service
									line.StateTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateService : 0;
									line.CountyTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateService : 0;
									line.LocalTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateService : 0;
									break;

								case parseInt(TAX_RATE_TYPES.Food):
									// Food
									line.StateTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateFood : 0;
									line.CountyTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateFood : 0;
									line.LocalTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateFood : 0;
									break;

								default:
									// Goods
									line.StateTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateGoods : 0;
									line.CountyTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateGoods : 0;
									line.LocalTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateGoods : 0;
									break;
							}
						},

						changeDiscountTaxType: function (line) {
							switch (parseInt(line.TaxRateTypeId) || 1) {
								case parseInt(TAX_RATE_TYPES.Service):
									// Service
									line.StateTaxRate = 0;
									line.CountyTaxRate = 0;
									line.LocalTaxRate = 0;
									line.TotalTax = 0;
									break;

								default:
									// Goods
									line.StateTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.StateTaxRateGoods : 0;
									line.CountyTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.CountyTaxRateGoods : 0;
									line.LocalTaxRate = $scope.newPO.selectedVendor ? $scope.newPO.selectedVendor.LocalTaxRateGoods : 0;
									break;
							}
						},

						getAccountParentIndex: function (account) {
							const parentIndex = _.findIndex($scope.newPO.PurchaseOrderAccounts, function (a) {
								return a.$$hashKey === account.$$hashKey;
							});
							return parentIndex;
						},

						setElementFocus: function (name, selectAll, cursorLeft) {
							setTimeout(function () {
								const elem = document.getElementsByName(name);
								const element = angular.element(elem);
								element.trigger('focus');
								if (selectAll === true) {
									element.trigger('select');
								}
								if (cursorLeft === true) {
									element[0].setSelectionRange(0, 0);
								}
							}, 100);
						},

						lineAmount: function (line) {
							line.Amount = emsRound(line.Quantity * line.UnitCost) || 0;
							return line.Amount;
						},

						lineTax: function (line) {
							if (line.Amount > 0 || line.IsDiscount === true) {
								// need to add in the shipping cost tax here by calculating percentages.
								// the shipping cost for each line is calculated every time the grand total changes
								// for the invoice.  After shipping is calculated, this function is called to
								// calculate the taxes on the Shipping allocated to this line.

								if (!_.isNumber(line.ShippingCost)) {
									line.ShippingCost = 0;
								}

								const lineStateShippingTax = calculateRoundedTax(line.ShippingCost, line.StateTaxRate);
								const lineCountyShippingTax = calculateRoundedTax(line.ShippingCost, line.CountyTaxRate);
								const lineLocalShippingTax = calculateRoundedTax(line.ShippingCost, line.LocalTaxRate);

								const stateTax = calculateRoundedTax(line.Amount, line.StateTaxRate);
								const countyTax = calculateRoundedTax(line.Amount, line.CountyTaxRate);
								const localTax = calculateRoundedTax(line.Amount, line.LocalTaxRate);

								// each tax amount should be rounded to 2 decimal places before being summed together for the final total
								line.TotalTax = stateTax + lineStateShippingTax + countyTax + lineCountyShippingTax + localTax + lineLocalShippingTax;

								line.TotalTax = emsRound(line.TotalTax * 100) / 100;
							} else {
								line.TotalTax = 0;
							}
							return line.TotalTax;
						},

						editTax: function (line) {
							$scope.selectedLine = line;
							$uibModal
								.open({
									template: require('@ajs/templates/fund/purchasing/purchaseOrder-taxupdate-modal.html'),
									backdrop: 'static',
									keyboard: false,
									scope: $scope,
									controller: [
										'$scope',
										'$uibModalInstance',
										function ($scope, editTaxModal) {
											$scope.tempState = angular.copy($scope.selectedLine.StateTaxRate);
											$scope.tempCounty = angular.copy($scope.selectedLine.CountyTaxRate);
											$scope.tempLocal = angular.copy($scope.selectedLine.LocalTaxRate);

											angular.extend($scope, {
												taxCancel: function () {
													editTaxModal.close();
												},
												updateTax: function () {
													if (!$scope.taxUpdateForm.$valid) {
														return;
													}
													editTaxModal.close({
														state: parseFloat($scope.tempState),
														county: parseFloat($scope.tempCounty),
														local: parseFloat($scope.tempLocal),
													});
												},
											});
										},
									],
								})
								.result.then(function (updatedTaxes) {
									if (updatedTaxes) {
										$scope.selectedLine.StateTaxRate = updatedTaxes.state;
										$scope.selectedLine.CountyTaxRate = updatedTaxes.county;
										$scope.selectedLine.LocalTaxRate = updatedTaxes.local;
									}
								});
						},

						lineTotal: function (line) {
							line.LineTotal =
								emsRound(line.TotalTax + parseFloat(line.Amount) + (line.ShippingCost ? parseFloat(line.ShippingCost) : 0)) || 0; // Added
							return line.LineTotal;
						},

						accountTotal: function (account) {
							_.throttle(() => {
								account.PurchaseOrderLines.forEach((line) => $scope.applyDiscountAmtPctChange(account, line));
							}, 1000);

							if (account.Account) {
								// do some calculations to determine whether the Account is over budget or not.
								let accntTotalPlusTax = _.reduce(
									account.PurchaseOrderLines,
									function (num, line) {
										return emsRound(num + line.TotalTax + parseFloat(line.Amount));
									},
									0
								);

								account.Account.remainingBudget = emsRound(account.Account.RemainingBudget - accntTotalPlusTax);
								if ($scope.vm.sitePOSetup && $scope.vm.sitePOSetup.PercentOverBudgetAllowed) {
									account.Account.budgetExceeded =
										emsRound(
											(account.Account.RemainingBudget * (100 + $scope.vm.sitePOSetup.PercentOverBudgetAllowed)) / 100 -
												accntTotalPlusTax
										) < 0;
								} else {
									account.Account.budgetExceeded = emsRound(account.Account.RemainingBudget - accntTotalPlusTax) < 0;
								}
							}

							let accntTotal = _.reduce(
								account.PurchaseOrderLines,
								function (num, line) {
									return emsRound(num + parseFloat(line.Amount));
								},
								0
							);
							return accntTotal;
						},

						subTotal: function () {
							if (!$scope.newPO) {
								return 0;
							}

							if (!$scope.newPO.PurchaseOrderAccounts) {
								return 0;
							}
							return _.reduce(
								$scope.newPO.PurchaseOrderAccounts,
								function (num, account) {
									return (
										num +
										_.reduce(
											account.PurchaseOrderLines,
											function (num, line) {
												return num + (!line.IsShipping ? line.Amount : 0);
											},
											0
										)
									);
								},
								0
							);
						},

						totalDiscount: function () {
							if (!$scope.newPO) {
								return 0;
							}
							if (!$scope.newPO.PurchaseOrderAccounts) {
								return 0;
							}
							const discount = _.reduce(
								$scope.newPO.PurchaseOrderAccounts,
								function (num, account) {
									return (
										num +
										_.reduce(
											account.PurchaseOrderLines,
											function (num, line) {
												return emsRound(num + (line.IsDiscount ? line.Amount : 0));
											},
											0
										)
									);
								},
								0
							);

							return Math.abs(discount);
						},

						totalTax: function () {
							if (!$scope.newPO) {
								return 0;
							}
							if (!$scope.newPO.PurchaseOrderAccounts) {
								return 0;
							}
							return _.reduce(
								$scope.newPO.PurchaseOrderAccounts,
								function (num, account) {
									return _.reduce(
										account.PurchaseOrderLines,
										function (num, line) {
											return emsRound(num + line.TotalTax);
										},
										num
									);
								},
								0
							);
						},

						/*
							This function returns the sum of shipping costs allocated across the po-req lines.
						*/
						totalCalculatedSH: function () {
							if (!$scope.newPO.PurchaseOrderAccounts) return 0;
							const totalSH = _.reduce(
								$scope.newPO.PurchaseOrderAccounts,
								function (num, account) {
									return (
										num +
										_.reduce(
											account.PurchaseOrderLines,
											function (num, line) {
												return num + parseFloat(line.ShippingCost);
											},
											0
										)
									);
								},
								0
							);
							return emsRound(totalSH);
						},

						/*
							This function calculates and sets the Shipping Cost for the po-req line passed in.
						*/
						setCalculatedShippingCost: function (line) {
							const linePercentage = line.Amount / $scope.subTotal();
							const lineShippingCost = emsRound($scope.newPO.ShippingCost * linePercentage);
							line.ShippingCost = lineShippingCost;
						},

						/*
							This function ensures the Total for Shipping Costs across po-req Lines
							equals the entered Shipping and Handling value for the Purchase Order / Requisition.
						*/
						syncShippingCost: function (makeFormDirty = false) {
							_.each($scope.newPO.PurchaseOrderAccounts, function (account) {
								_.each(account.PurchaseOrderLines, function (line) {
									$scope.setCalculatedShippingCost(line);
								});
							});

							if (makeFormDirty) {
								$scope.purchaseOrderForm.$setDirty();
							}

							if ($scope.totalCalculatedSH() !== Number($scope.newPO.ShippingCost)) {
								let outage = emsRound(parseFloat($scope.totalCalculatedSH() - Number($scope.newPO.ShippingCost)));

								if (outage !== 0) {
									_.each($scope.newPO.PurchaseOrderAccounts, function (account) {
										const lines = account.PurchaseOrderLines.filter((f) => f.Amount > 0 && !f.IsDiscount && !f.IsShipping);
										_.each(
											lines.sort((a, b) => b.Amount - a.Amount),
											function (sortedLine) {
												const line = _.find(account.PurchaseOrderLines, function (f) {
													return f === sortedLine;
												});
												if (!_.isUndefined(line) && outage !== 0) {
													const increment = outage > 0 ? -0.01 : 0.01;
													line.ShippingCost = emsRound(line.ShippingCost + increment);
													outage = emsRound(outage + increment);
												}
											}
										);
									});
								}
							}
						},

						grandTotal: function () {
							if (!$scope.newPO) {
								$scope.poReqGrandTotal = 0;
								return;
							}
							if (!$scope.newPO.PurchaseOrderAccounts) {
								$scope.poReqGrandTotal = 0;
								return;
							}

							const grandTotal =
								$scope.subTotal() + ($scope.newPO.ShippingCost ? parseFloat($scope.newPO.ShippingCost) : 0) + $scope.totalTax();

							$scope.newPO.maxAmountExceeded =
								$scope.vm.sitePOSetup && $scope.vm.sitePOSetup.MaxPOAmount && grandTotal > $scope.vm.sitePOSetup.MaxPOAmount;

							$scope.poReqGrandTotal = grandTotal;

							return $scope.poReqGrandTotal;
						},

						searchAccountsbyAccountNumber: function (value, limit) {
							let typeaheadLimit = !_.isNull(limit) && !_.isUndefined(limit) ? limit : $scope.vm.typeaheadLimit;
							return accountService
								.searchFundAccount([ACCOUNT_TYPES.Expense, ACCOUNT_TYPES.Net], '', value, typeaheadLimit, true)
								.then(finishSearchAccounts);

							function finishSearchAccounts(response) {
								return response.data.accounts;
							}
						},

						selectAccountFromList: function (item) {
							const modalConfig = {
								accountTypeIds: [ACCOUNT_TYPES.Expense, ACCOUNT_TYPES.Net],
								allowAddNew: false,
								moduleName: $scope.vm.module,
							};

							const selectFunction = function (account) {
								item.AccountId = account.Id;
								item.Account = {};
								item.Account.Id = account.Id;
								item.Account.AccountNumber = account.AccountNumber;
								item.Account.Description = account.Description;
								$scope.getAccountRemainingBudget(item);

								$scope.purchaseOrderForm.$setDirty();
							};

							dialogSearchHelper.searchAccounts(modalConfig, selectFunction);
						},

						getAccountRemainingBudget: function (account) {
							let poId = $scope.newPO.Id ? $scope.newPO.Id : 0;
							let effectiveDT = $scope.newPO.EffectiveDT ? $scope.newPO.EffectiveDT : moment().toDate();
							return accountService
								.getAccountRemainingBudget(poId, account.Account.Id, effectiveDT)
								.then(finishGettingAccountRemainingBudget);

							function finishGettingAccountRemainingBudget(response) {
								account.Account.RemainingBudget = response.data.remainingBudget;
								return angular.noop;
							}
						},

						effectiveDateChanged: function () {
							var promises = [];
							angular.forEach($scope.newPO.PurchaseOrderAccounts, function (poAccount) {
								promises.push($scope.getAccountRemainingBudget(poAccount));
							});
							return $q.all(promises);
						},

						isOrderStateAndZipRequired: function () {
							if ($scope.newPO.OrderCountry === 'US') {
								$scope.vm.postalCodeMinLength = '0';
								return true;
							}
							return false;
						},

						isOrderProvinceAndPostalCodeRequired: function () {
							if ($scope.newPO.OrderCountry === 'CA') {
								$scope.vm.postalCodeMinLength = '6';
								return true;
							}
							if ($scope.newPO.OrderCountry === 'UK') {
								$scope.vm.postalCodeMinLength = '6';
								return true;
							}
							return false;
						},

						validatePO: function () {
							var isValid = true;

							if ($scope.newPO.PurchaseOrderAccounts.length === 0) {
								$scope.vm.validationErrors.push('At least one Account must be added.');
								isValid = false;
							}

							_.each($scope.newPO.PurchaseOrderAccounts, function (account) {
								_.each(account.PurchaseOrderLines, function (line) {
									if (line.Quantity * line.UnitCost > 9999999) {
										$scope.vm.validationErrors.push(
											'Account # ' +
												account.Account.AccountNumber +
												', item description ' +
												line.Description +
												', calculated amount is too high. Reduce either the quantity or the unit cost.'
										);
										isValid = false;
									}
								});
							});

							return isValid;
						},

						selectCountry: function (country) {
							if (!$scope.newPO.isClosed) {
								$scope.newPO.OrderCountry = country;
								$scope.newPO.OrderState = null;
								$scope.newPO.OrderZip = null;
							}
						},

						openPOSendPopup: function (purchaseOrderId) {
							$uibModal
								.open({
									windowClass: 'poPrintModal',
									template: require('@ajs/templates/fund/payable/purchaseorder-emailprint-modal.html'),
									backdrop: 'static',
									keyboard: false,
									scope: $scope,
									controller: [
										'$scope',
										'$q',
										'$uibModalInstance',
										'purchaseOrderService',
										function ($scope, $q, sendPopupModal, purchaseOrderService) {
											$q.all([getPreview()]);

											function getPreview() {
												$scope.gettingPreviewPromise = purchaseOrderService
													.getPurchaseOrderImagePreview(purchaseOrderId, $scope.vm.viewPurchaseOrder.selectedCopyNumber)
													.then(finishedGettingPreview);

												function finishedGettingPreview(response) {
													$scope.vm.viewPurchaseOrder.images = response.data.images;
													$scope.gettingPreviewPromise = purchaseOrderService
														.getPOSetupInfo(purchaseOrderId)
														.then(_.partial(finishedGettingPOSetupInfo));
													function finishedGettingPOSetupInfo(responsePurchase) {
														$scope.vm.numberOfCopies = responsePurchase.data.setupInfo.NumberOfCopies;
														$scope.vm.emailReceiptCopyNumber = responsePurchase.data.setupInfo.EmailReceiptCopyNumber;
														$scope.vm.availableCopies = [
															{
																v: 1,
																n: 'Vendor Copy',
															},
														];
														for (var i = 1; i < 3; i++) {
															$scope.vm.availableCopies.push({
																v: i + 1,
																n: 'Copy ' + (i + 1),
															});
														}
													}

													return angular.noop;
												}
											}

											angular.extend($scope, {
												getPreview: getPreview,
												cancel: function () {
													sendPopupModal.close();
												},
												sendEmail: function () {
													var purchaseOrderToSend = [
														{
															Id: purchaseOrderId,
															SiteId: $scope.newPO.SiteId,
															Copy1: $scope.vm.viewPurchaseOrder.emailVendorCopy,
															Copy2: $scope.vm.viewPurchaseOrder.emailCopyTwo,
															Copy3: $scope.vm.viewPurchaseOrder.emailCopyThree,
														},
													];

													if (
														!$scope.vm.viewPurchaseOrder.emailVendorCopy &&
														!$scope.vm.viewPurchaseOrder.emailCopyTwo &&
														!$scope.vm.viewPurchaseOrder.emailCopyThree
													) {
														return;
													}

													$scope.emailPromise = purchaseOrderService
														.emailPurchaseOrder(purchaseOrderToSend)
														.then(function (response) {
															var success = response.data.numberFailed === 0;
															sendPopupModal.close({
																type: 'Email',
																result: success,
															});
														});
												},
												print: function () {
													var purchaseOrderToPrint = [
														{
															Id: purchaseOrderId,
															Copy1: $scope.vm.viewPurchaseOrder.printVendorCopy,
															Copy2: $scope.vm.viewPurchaseOrder.printCopyTwo,
															Copy3: $scope.vm.viewPurchaseOrder.printCopyThree,
														},
													];

													if (
														!$scope.vm.viewPurchaseOrder.printVendorCopy &&
														!$scope.vm.viewPurchaseOrder.printCopyTwo &&
														!$scope.vm.viewPurchaseOrder.printCopyThree
													) {
														return;
													}

													var url = environment.API_URL + '/api/purchaseorder/printpos';

													// Load the PDF via AJAX request. This allows us to check if the request was successful.
													var xhr = new XMLHttpRequest();
													xhr.open('POST', url, true);
													xhr.responseType = 'blob';
													xhr.setRequestHeader('Authorization', authInterceptorService.bearerToken());
													xhr.setRequestHeader('Content-type', 'application/json');

													xhr.onload = function (oEvent) {
														if (xhr.status === 200) {
															let blob = new Blob([xhr.response], {
																type: 'application/pdf',
															});

															// IE (as of 11) doesn't allow window.open with Blobs, so we use their native method.
															if (window.navigator.msSaveOrOpenBlob) {
																window.navigator.msSaveOrOpenBlob(blob, 'PurchaseOrder.pdf');
															} else {
																let bloburl = URL.createObjectURL(blob);
																window.open(bloburl);
															}
															$scope.isReportFinished = true;

															sendPopupModal.close({
																type: 'Print',
																result: true,
															});
														} else {
															let msgList = [];
															if (xhr.status === 204) {
																msgList.push('No data available for this request!');
															} else {
																msgList.push('An error occurred during the request.');
																msgList.push('If the problem continues, please contact your Administrator!');
															}
															$scope.isReportFinished = true;
															dialogHelper.openMessageBox('Report Message', null, msgList, 'Warning');
														}
													};

													xhr.send(JSON.stringify(purchaseOrderToPrint));
												},
											});
										},
									],
								})
								.result.then(function (status) {
									if (!status) return;

									$scope.vm.viewPurchaseOrder.activeImage = 0;
									$scope.vm.viewPurchaseOrder.selectedCopyNumber = 1;
									$scope.vm.viewPurchaseOrder.printVendorCopy = false;
									$scope.vm.viewPurchaseOrder.printCopyTwo = false;
									$scope.vm.viewPurchaseOrder.printCopyThree = false;
									$scope.vm.viewPurchaseOrder.success = status.result;

									if (status.type === 'Print') {
										if (status.result === true) {
											$scope.vm.viewPurchaseOrder.confirmText = '1 PO was printed';
										} else {
											$scope.vm.viewPurchaseOrder.confirmText = '1 PO failed to print';
										}
									} else if (status.type === 'Email') {
										if (status.result === true) {
											$scope.vm.viewPurchaseOrder.confirmText = '1 PO was emailed to customer';
										} else {
											$scope.vm.viewPurchaseOrder.confirmText = '1 PO failed to send by email';
										}
									}

									$uibModal.open({
										template: require('@ajs/templates/fund/purchasing/purchaseOrder-sendsuccess-modal.html'),
										backdrop: 'static',
										keyboard: false,
										scope: $scope,
										controller: [
											'$scope',
											'$uibModalInstance',
											function ($scope, sendSuccessModal) {
												angular.extend($scope, {
													done: function () {
														sendSuccessModal.close();
													},
												});
											},
										],
									});
								});
						},

						approveRequisition: function () {
							const reqs = [$scope.newPO.Id];
							$scope.busyPromise = purchaseOrderService
								.approveRequisitions(reqs, $scope.newPO.NextApprover)
								.then(finishApproveRequisition);

							function finishApproveRequisition(response) {
								if (response.data.errors) {
									dialogHelper.openMessageBox('Error: Invalid approver!', response.data.errors, null, 'Warning');
									return;
								}

								if (response.data.createdPONumbers) {
									if (response.data.createdPONumbers.length > 0) {
										const poNum = response.data.createdPONumbers[0];
										const message = `PO # ${poNum} has been created.`;
										dialogHelper.openMessageBox('Purchase Order Created!', message, null, 'Info');
									}
								}

								modalInstance.close('Added');
							}
						},

						savePO: function (addAnother) {
							if ($scope.newPO.maxAmountExceeded) {
								return;
							}

							if ($scope.vm.sitePOSetup && $scope.vm.sitePOSetup.AllowBackDatedPO !== true) {
								//Validate User does not Back Date Req or PO
								if ($scope.purchaseOrderForm.orderDate.$dirty) {
									if (moment($scope.newPO.EffectiveDT).startOf('day') < moment(Date.now()).startOf('day')) {
										dialogHelper.openMessageBox(
											`${$scope.vm.purchasingTypeDesc} Error`,
											"Order Date can not be before today's date.",
											null,
											'Warning',
											() => {
												$scope.setElementFocus('orderDate', true);
											}
										);
										return;
									}
								}
							}

							$scope.vm.validationErrors = [];

							if (addAnother) {
								$scope.vm.addAnother = true;
							}

							// validate OrderZip
							$scope.purchaseOrderForm.zip.$setValidity('validZip', true);
							$scope.purchaseOrderForm.postalCodeCA.$setValidity('validZip', true);
							$scope.purchaseOrderForm.postalCodeOther.$setValidity('validZip', true);

							var isValid = true;
							if (($scope.newPO.OrderZip || '').length > 0) {
								isValid = isPostalCodeValid($scope.newPO.OrderCountry, $scope.newPO.OrderZip);
							}

							switch ($scope.newPO.OrderCountry) {
								case 'US':
									$scope.purchaseOrderForm.zip.$setValidity('validZip', isValid);
									break;
								case 'CA':
									$scope.purchaseOrderForm.postalCodeCA.$setValidity('validZip', isValid);
									break;
								default:
									$scope.purchaseOrderForm.postalCodeOther.$setValidity('validZip', isValid);
									break;
							}

							if (!$scope.validatePO() || !$scope.purchaseOrderForm.$valid) return false;

							if ($scope.newPO.Vendor) {
								$scope.newPO.VendorId = $scope.newPO.Vendor.Id;
								$scope.newPO.OrderTo = $scope.newPO.Vendor.ShortName + ' - ' + $scope.newPO.Vendor.VendorName;
							}

							if ($scope.newPO.Site) {
								$scope.newPO.ShipTo = $scope.newPO.Site.SiteCode + ' ' + $scope.newPO.Site.SiteName;
							}
							if ($scope.newPO.Id) {
								$scope.vm.busyMessage = BUSY_MESSAGE.Saving;
								$scope.busyPromise = purchaseOrderService.updatePurchaseOrder($scope.newPO).then(finishAddingPurchaseOrder);
							} else {
								$scope.vm.busyMessage = BUSY_MESSAGE.Saving;
								$scope.busyPromise = purchaseOrderService.addPurchaseOrder($scope.newPO).then(finishAddingPurchaseOrder);
							}

							function finishAddingPurchaseOrder(response) {
								if (!response.data.isValid) {
									$scope.errors = response.data.errors;
									if (Array.isArray($scope.errors)) {
										angular.forEach(response.data.errors, function (err) {
											$scope.vm.validationErrors.push(err);
										});
									} else {
										$scope.vm.validationErrors.push($scope.errors);
									}
									return;
								}

								if (response.data.isValid) {
									// show over budget Accounts if any
									if (response.data.overBudgetAccounts.length > 0) {
										dialogHelper.openMessageBox($scope.vm.purchasingTypeDesc, null, response.data.overBudgetAccounts, 'Warning');
									}

									if ($scope.vm.addAnother === true) {
										$scope.purchaseOrderForm.$setPristine();
										$scope.purchaseOrderForm.$setUntouched();
										var promises = [];
										if (closeActionCallBack) {
											promises.push(closeActionCallBack(true));
										}
										promises.push($scope.initialize(true));
										return $q.all(promises);
									} else {
										modalInstance.close('Added');
									}
								}
							}
						},

						cancel: function () {
							$scope.vm.validationErrors = [];
							modalInstance.close();
						},
					});

					$scope.initialize();
				},
			];

			$uibModal
				.open({
					template: require('@ajs/templates/fund/purchasing/purchaseOrder-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					windowClass: 'app-modal-window-autoWidth',
					controller: addEditDialogController,
				})
				.result.then(function (added) {
					if (closeActionCallBack) {
						closeActionCallBack(added);
					}
				});
		}

		return {
			openAddEditDialog: openAddEditDialog,
		};
	},
]);
